import React from 'react';
import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay';

// components
import AttributeLink from './AttributeLink';

// helpers
import get from 'lodash.get';

function PdpSharedDetailAttributeLink(props) {
    const attributes = get(props, 'attributes') || [];
    const categories = get(props, 'item.classification.categories');

    if (!attributes.length) {
        return null;
    }

    return (
        <span data-tn={props.dataTn}>
            {attributes.map((attr, index) => {
                const key = `${get(attr, 'attributeKey')}-${get(attr, 'option.name')}`;
                return (
                    <span key={key}>
                        {index > 0 && ', '}
                        <AttributeLink attribute={attr} categories={categories} />
                    </span>
                );
            })}
        </span>
    );
}

PdpSharedDetailAttributeLink.propTypes = {
    dataTn: PropTypes.string.isRequired,
    item: PropTypes.object.isRequired,
    attributes: PropTypes.array.isRequired,
};

export default createFragmentContainer(PdpSharedDetailAttributeLink, {
    item: graphql`
        fragment PdpSharedDetailAttributeLink_item on Item {
            classification {
                categories {
                    precedence
                    category {
                        browseUrl
                    }
                }
            }
        }
    `,
    attributes: graphql`
        fragment PdpSharedDetailAttributeLink_attributes on AttributeValue @relay(plural: true) {
            attributeKey
            publishedItemsCount
            option {
                name
                urlLabel
            }
        }
    `,
});
